import { ArrowUpRightIcon, BookmarkIcon } from 'lucide-react';

import type { BookmarkLink } from '@/features/portfolio/types/bookmarks';
import { cn } from '@/lib/utils';

export function BookmarkItem({
  className,
  bookmark,
  level = 0,
}: {
  className?: string;
  bookmark: BookmarkLink;
  level?: number;
}) {
  return (
    <a
      className={cn(
        'group/bookmark flex items-center pr-2 hover:bg-accent2 border-b border-edge transition-colors',
        level > 0 && 'border-l border-dashed border-edge',
        className
      )}
      style={{ paddingLeft: `${level * 16 + 16}px` }}
      href={bookmark.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="w-4 shrink-0" />

      <div
        className={cn(
          'mx-4 flex size-6 shrink-0 items-center justify-center rounded-lg select-none',
          'border border-muted-foreground/15 ring-1 ring-edge ring-offset-1 ring-offset-background',
          'bg-muted text-muted-foreground [&_svg]:size-4'
        )}
        aria-hidden
      >
        <BookmarkIcon />
      </div>

      <div className="flex-1 border-l border-dashed border-edge p-4 pr-2">
        <h3 className="leading-snug font-medium text-balance underline-offset-4 group-hover/bookmark:underline">
          {bookmark.title}
        </h3>
        {bookmark.description && (
          <p className="text-sm text-muted-foreground mt-0.5 line-clamp-1">
            {bookmark.description}
          </p>
        )}
      </div>

      <ArrowUpRightIcon
        className="size-4 text-muted-foreground shrink-0 mr-2"
        aria-hidden
      />
    </a>
  );
}
